/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from "./request";
// @ts-ignore
import makeRequestHook from "./makeRequestHook";

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig["requestDataOptional"] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/187" as any;
const devUrl_0_0_0_0 = "" as any;
const prodUrl_0_0_0_0 = "" as any;
const dataKey_0_0_0_0 = "data" as any;

export interface BaobanPcGoodsListRequest {
  /**
   * 搜索
   */
  search_key: string;
  /**
   * 1.在售中 2.带上架 3.已下架 4.草稿
   */
  on_sale: string;
  /**
   * page
   */
  page: string;
  /**
   * page_size
   */
  page_size: string;
  /**
   * 品类筛选(数组)
   */
  cat_id: string[];
  /**
   * 标签信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) is_advance_support  提前上新  is_no_reason_support  无理由退货  goods_type  特价  has_consignment_stock  前置仓有库存  例子: 如果要传提前上新+特价, 那tag_info就传 "is_advance_support,goods_type"
   */
  tag_info: string;
  /**
   * 信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) no_real_img  无实拍图   no_video  无小视频  fill_in_sku_stock  已填库存需更新  un_stock_goods  前置仓滞销  no_sku_name 没有sku编码
   */
  message_info: string;
  /**
   * 价格筛选
   */
  market_price: {
    /**
     * min
     */
    min: string;
    /**
     * max
     */
    max: string;
  };
}

export interface BaobanPcGoodsListResponse {
  list?: {
    /**
     * 货号
     */
    goods_no: string;
    /**
     * 首次上架时间 (string) YYYY-MM-DD格式
     */
    first_sale_time: string;
    /**
     * 草稿id
     */
    gfs_id: string;
    /**
     * 商品名
     */
    goods_name: string;
    /**
     * 款号
     */
    goods_kh: string;
    /**
     * 图片
     */
    goods_img: string;
    /**
     * 拿货价
     */
    market_price: string;
    /**
     * 特价拿货价
     */
    prefer_price: string;
    /**
     * 标签
     */
    tag_list: string[];
    /**
     * sku颜色尺码信息
     */
    sku_co_si_name_list: string[];
    /**
     * 今日销量展示
     */
    sales_text: string;
    /**
     * 下架跳转流程 1.通用场景, 2.商品信息再审核, 3.库存设置场景
     */
    turn_type: string;
    /**
     * 下架原因
     */
    withdraw_reason: string;
    /**
     * 草稿状态名称
     */
    draft_status_name: number;
    /**
     * 各种时间
     */
    time: string;
    /**
     * 草稿状态 状态{0:待审核,1:上架,2:驳回,3:草稿}
     */
    draft_status: string;
    /**
     * 0默认 1仅有一次履约的下架记录 2.有2次以上的履约记录
     */
    low_performance_status: string;
    /**
     * 是否是导入的 0否 1是
     */
    is_import: string;
    /**
     * 搭配购数量
     */
    collection_num: string;
  }[];
  total?: number;
  /**
   * tab数量
   */
  tab_total?: {
    /**
     * on_sale=1数量
     */
    tab1?: number;
    /**
     * on_sale=2数量
     */
    tab2?: number;
    /**
     * on_sale=3数量
     */
    tab3?: number;
    /**
     * on_sale=4数量
     */
    tab4?: number;
  };
  /**
   * 没有sku编码数量
   */
  no_sku_name_num: string;
}

type BaobanPcGoodsListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGoodsList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGoodsListRequestConfig: BaobanPcGoodsListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGoodsList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        search_key: { type: "string", description: "搜索" },
        on_sale: {
          type: "string",
          description: "1.在售中 2.带上架 3.已下架 4.草稿",
        },
        page: { type: "string", description: "page" },
        page_size: { type: "string", description: "page_size" },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "品类筛选(数组)",
        },
        tag_info: {
          type: "string",
          description:
            '标签信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) is_advance_support  提前上新  is_no_reason_support  无理由退货  goods_type  特价  has_consignment_stock  前置仓有库存  例子: 如果要传提前上新+特价, 那tag_info就传 "is_advance_support,goods_type"',
        },
        message_info: {
          type: "string",
          description:
            "信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) no_real_img  无实拍图   no_video  无小视频  fill_in_sku_stock  已填库存需更新  un_stock_goods  前置仓滞销  no_sku_name 没有sku编码",
        },
        market_price: {
          type: "object",
          properties: {
            min: { type: "string", description: "min" },
            max: { type: "string", description: "max" },
          },
          required: ["min", "max"],
          description: "价格筛选",
        },
      },
      required: [
        "search_key",
        "cat_id",
        "page_size",
        "page",
        "on_sale",
        "market_price",
        "tag_info",
        "message_info",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              goods_no: { type: "string", description: "货号" },
              first_sale_time: {
                type: "string",
                description: "首次上架时间 (string) YYYY-MM-DD格式",
              },
              gfs_id: { type: "string", description: "草稿id" },
              goods_name: { type: "string", description: "商品名" },
              goods_kh: { type: "string", description: "款号" },
              goods_img: { type: "string", description: "图片" },
              market_price: { type: "string", description: "拿货价" },
              prefer_price: { type: "string", description: "特价拿货价" },
              tag_list: {
                type: "array",
                items: { type: "string" },
                description: "标签",
              },
              sku_co_si_name_list: {
                type: "array",
                items: { type: "string" },
                description: "sku颜色尺码信息",
              },
              sales_text: { type: "string", description: "今日销量展示" },
              turn_type: {
                type: "string",
                description:
                  "下架跳转流程 1.通用场景, 2.商品信息再审核, 3.库存设置场景",
              },
              withdraw_reason: { type: "string", description: "下架原因" },
              draft_status_name: {
                type: "number",
                description: "草稿状态名称",
              },
              time: { type: "string", description: "各种时间" },
              draft_status: {
                type: "string",
                description: "草稿状态 状态{0:待审核,1:上架,2:驳回,3:草稿}",
              },
              low_performance_status: {
                type: "string",
                description:
                  "0默认 1仅有一次履约的下架记录 2.有2次以上的履约记录",
              },
              is_import: {
                type: "string",
                description: "是否是导入的 0否 1是",
              },
              collection_num: { type: "string", description: "搭配购数量" },
            },
            required: [
              "goods_no",
              "gfs_id",
              "goods_name",
              "goods_kh",
              "goods_img",
              "market_price",
              "prefer_price",
              "tag_list",
              "sku_co_si_name_list",
              "sales_text",
              "turn_type",
              "withdraw_reason",
              "draft_status_name",
              "time",
              "draft_status",
              "low_performance_status",
              "is_import",
              "first_sale_time",
              "collection_num",
            ],
          },
        },
        total: { type: "number" },
        tab_total: {
          type: "object",
          properties: {
            tab1: { type: "number", description: "on_sale=1数量" },
            tab2: { type: "number", description: "on_sale=2数量" },
            tab3: { type: "number", description: "on_sale=3数量" },
            tab4: { type: "number", description: "on_sale=4数量" },
          },
          description: "tab数量",
        },
        no_sku_name_num: { type: "string", description: "没有sku编码数量" },
      },
      required: ["no_sku_name_num"],
    },
    requestFunctionName: "baobanPcGoodsList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGoodsList = /*#__PURE__*/ (
  requestData: BaobanPcGoodsListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGoodsListResponse>(
    prepare(baobanPcGoodsListRequestConfig, requestData),
    ...args,
  );
};

baobanPcGoodsList.requestConfig = baobanPcGoodsListRequestConfig;

export const useBaobanPcGoodsList = /*#__PURE__*/ makeRequestHook<
  BaobanPcGoodsListRequest,
  BaobanPcGoodsListRequestConfig,
  ReturnType<typeof baobanPcGoodsList>
>(baobanPcGoodsList);

export interface BaobanPcOffShelfGoodsCheckRequest {
  /**
   * 商品goods_no
   */
  goods_no: string[];
  /**
   * sku 用逗号隔开
   */
  sku: string;
}

export interface BaobanPcOffShelfGoodsCheckResponse {
  /**
   * 是否有断订单, 1是 0否
   */
  is_has?: string;
}

type BaobanPcOffShelfGoodsCheckRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcOffShelfGoodsCheck",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcOffShelfGoodsCheckRequestConfig: BaobanPcOffShelfGoodsCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcOffShelfGoodsCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: {
          type: "array",
          items: { type: "string" },
          description: "商品goods_no",
        },
        sku: { type: "string", description: "sku 用逗号隔开" },
      },
      required: ["goods_no", "sku"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        is_has: { type: "string", description: "是否有断订单, 1是 0否" },
      },
    },
    requestFunctionName: "baobanPcOffShelfGoodsCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcOffShelfGoodsCheck = /*#__PURE__*/ (
  requestData: BaobanPcOffShelfGoodsCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcOffShelfGoodsCheckResponse>(
    prepare(baobanPcOffShelfGoodsCheckRequestConfig, requestData),
    ...args,
  );
};

baobanPcOffShelfGoodsCheck.requestConfig =
  baobanPcOffShelfGoodsCheckRequestConfig;

export const useBaobanPcOffShelfGoodsCheck = /*#__PURE__*/ makeRequestHook<
  BaobanPcOffShelfGoodsCheckRequest,
  BaobanPcOffShelfGoodsCheckRequestConfig,
  ReturnType<typeof baobanPcOffShelfGoodsCheck>
>(baobanPcOffShelfGoodsCheck);

export interface BaobanPcOffShelfGoodsRequest {
  /**
   * goods_no 数组
   */
  goods_no: string[];
  /**
   * 是否有断订单, 1是 0否
   */
  close_order: string;
}

export interface BaobanPcOffShelfGoodsResponse {}

type BaobanPcOffShelfGoodsRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcOffShelfGoods",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcOffShelfGoodsRequestConfig: BaobanPcOffShelfGoodsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcOffShelfGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: {
          type: "array",
          items: {
            type: "string",
            description: "是否从sku断采购订单 1是  0否",
          },
          description: "goods_no 数组",
        },
        close_order: { type: "string", description: "是否有断订单, 1是 0否" },
      },
      required: ["goods_no", "close_order"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcOffShelfGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcOffShelfGoods = /*#__PURE__*/ (
  requestData: BaobanPcOffShelfGoodsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcOffShelfGoodsResponse>(
    prepare(baobanPcOffShelfGoodsRequestConfig, requestData),
    ...args,
  );
};

baobanPcOffShelfGoods.requestConfig = baobanPcOffShelfGoodsRequestConfig;

export const useBaobanPcOffShelfGoods = /*#__PURE__*/ makeRequestHook<
  BaobanPcOffShelfGoodsRequest,
  BaobanPcOffShelfGoodsRequestConfig,
  ReturnType<typeof baobanPcOffShelfGoods>
>(baobanPcOffShelfGoods);

export interface BaobanPcSaleToSpecialRequest {
  /**
   * goods_no
   */
  goods_nos: string[];
}

export interface BaobanPcSaleToSpecialResponse {
  /**
   * 错误的文案
   */
  error_log_list: string[];
}

type BaobanPcSaleToSpecialRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcSaleToSpecial",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSaleToSpecialRequestConfig: BaobanPcSaleToSpecialRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcSaleToSpecial",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_nos: {
          type: "array",
          items: { type: "string" },
          description: "goods_no",
        },
      },
      required: ["goods_nos"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        error_log_list: {
          type: "array",
          items: { type: "string" },
          description: "错误的文案",
        },
      },
      required: ["error_log_list"],
    },
    requestFunctionName: "baobanPcSaleToSpecial",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSaleToSpecial = /*#__PURE__*/ (
  requestData: BaobanPcSaleToSpecialRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSaleToSpecialResponse>(
    prepare(baobanPcSaleToSpecialRequestConfig, requestData),
    ...args,
  );
};

baobanPcSaleToSpecial.requestConfig = baobanPcSaleToSpecialRequestConfig;

export const useBaobanPcSaleToSpecial = /*#__PURE__*/ makeRequestHook<
  BaobanPcSaleToSpecialRequest,
  BaobanPcSaleToSpecialRequestConfig,
  ReturnType<typeof baobanPcSaleToSpecial>
>(baobanPcSaleToSpecial);

export interface BaobanPcDelGoodsRequest {
  /**
   * 商品id 编辑的时候传
   */
  goods_no: string;
  /**
   * 草稿id 草稿的时候传
   */
  gfs_id: string;
}

export interface BaobanPcDelGoodsResponse {}

type BaobanPcDelGoodsRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcDelGoods",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcDelGoodsRequestConfig: BaobanPcDelGoodsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcDelGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: { type: "string", description: "商品id 编辑的时候传" },
        gfs_id: { type: "string", description: "草稿id 草稿的时候传" },
      },
      required: ["goods_no", "gfs_id"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcDelGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcDelGoods = /*#__PURE__*/ (
  requestData: BaobanPcDelGoodsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcDelGoodsResponse>(
    prepare(baobanPcDelGoodsRequestConfig, requestData),
    ...args,
  );
};

baobanPcDelGoods.requestConfig = baobanPcDelGoodsRequestConfig;

export const useBaobanPcDelGoods = /*#__PURE__*/ makeRequestHook<
  BaobanPcDelGoodsRequest,
  BaobanPcDelGoodsRequestConfig,
  ReturnType<typeof baobanPcDelGoods>
>(baobanPcDelGoods);

export interface BaobanPcRevokeCheckRequest {
  /**
   * 草稿id
   */
  gfs_id: string;
}

export interface BaobanPcRevokeCheckResponse {}

type BaobanPcRevokeCheckRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcRevokeCheck",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcRevokeCheckRequestConfig: BaobanPcRevokeCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcRevokeCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { gfs_id: { type: "string", description: "草稿id" } },
      required: ["gfs_id"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcRevokeCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcRevokeCheck = /*#__PURE__*/ (
  requestData: BaobanPcRevokeCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcRevokeCheckResponse>(
    prepare(baobanPcRevokeCheckRequestConfig, requestData),
    ...args,
  );
};

baobanPcRevokeCheck.requestConfig = baobanPcRevokeCheckRequestConfig;

export const useBaobanPcRevokeCheck = /*#__PURE__*/ makeRequestHook<
  BaobanPcRevokeCheckRequest,
  BaobanPcRevokeCheckRequestConfig,
  ReturnType<typeof baobanPcRevokeCheck>
>(baobanPcRevokeCheck);

export interface BaobanPcExportGoodsLibRequest {}

export interface BaobanPcExportGoodsLibResponse {
  file?: string;
}

type BaobanPcExportGoodsLibRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcExportGoodsLib",
    "data",
    string,
    string,
    true
  >
>;

const baobanPcExportGoodsLibRequestConfig: BaobanPcExportGoodsLibRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcExportGoodsLib",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
      type: "object",
      properties: { file: { type: "string" } },
    },
    requestFunctionName: "baobanPcExportGoodsLib",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcExportGoodsLib = /*#__PURE__*/ (
  requestData?: BaobanPcExportGoodsLibRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcExportGoodsLibResponse>(
    prepare(baobanPcExportGoodsLibRequestConfig, requestData),
    ...args,
  );
};

baobanPcExportGoodsLib.requestConfig = baobanPcExportGoodsLibRequestConfig;

export const useBaobanPcExportGoodsLib = /*#__PURE__*/ makeRequestHook<
  BaobanPcExportGoodsLibRequest,
  BaobanPcExportGoodsLibRequestConfig,
  ReturnType<typeof baobanPcExportGoodsLib>
>(baobanPcExportGoodsLib);

export interface BaobanPcImportSkuStockRequest {
  timestamp: string;
  sign: string;
  /**
   * 导入文档url
   */
  file: string;
}

export interface BaobanPcImportSkuStockResponse {
  /**
   * 处理结果提示
   */
  result?: string;
  /**
   * 错误文档
   */
  file?: string;
}

type BaobanPcImportSkuStockRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcImportSkuStock",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcImportSkuStockRequestConfig: BaobanPcImportSkuStockRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcImportSkuStock",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      required: ["timestamp", "sign", "file"],
      properties: {
        timestamp: { type: "string" },
        sign: { type: "string", description: "" },
        file: { type: "string", description: "导入文档url" },
      },
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        result: { type: "string", description: "处理结果提示" },
        file: { type: "string", description: "错误文档" },
      },
      required: [],
    },
    requestFunctionName: "baobanPcImportSkuStock",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcImportSkuStock = /*#__PURE__*/ (
  requestData: BaobanPcImportSkuStockRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcImportSkuStockResponse>(
    prepare(baobanPcImportSkuStockRequestConfig, requestData),
    ...args,
  );
};

baobanPcImportSkuStock.requestConfig = baobanPcImportSkuStockRequestConfig;

export const useBaobanPcImportSkuStock = /*#__PURE__*/ makeRequestHook<
  BaobanPcImportSkuStockRequest,
  BaobanPcImportSkuStockRequestConfig,
  ReturnType<typeof baobanPcImportSkuStock>
>(baobanPcImportSkuStock);

export interface BaobanPcGetSkuDataRequest {
  /**
   * goods_no
   */
  goods_no: string;
}

export interface BaobanPcGetSkuDataResponse {
  /**
   * 是否有启用的sku 1是 0否
   */
  sku_on_sale?: string;
  /**
   * 颜色尺码
   */
  colorSizeData?: {
    key?: string;
    label?: string;
    thumb?: {
      name?: string;
    };
    size?: {
      sku?: string;
      key?: string;
      label?: string;
      real_stock?: string;
      sale_stock?: string;
      virtual_stock?: string;
      supply_stock?: string;
      status?: boolean;
      update_stock?: string;
      sku_sort?: string;
      schedule_day?: string;
      sku_name?: string;
      in_stock_num?: string;
      pre_in_stock_num?: string;
      amount_stock_num?: string;
      update_promise_num?: string;
      update_promise_stock?: string;
      promise_num?: string;
      promise_sale_num?: string;
    }[];
  }[];
  /**
   * 特价锁库时间是否过期 0 没过期 1过期
   */
  if_lock_time_end?: string;
}

type BaobanPcGetSkuDataRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetSkuData",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetSkuDataRequestConfig: BaobanPcGetSkuDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetSkuData",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { goods_no: { type: "string", description: "goods_no" } },
      required: ["goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        sku_on_sale: { type: "string", description: "是否有启用的sku 1是 0否" },
        colorSizeData: {
          type: "array",
          items: {
            type: "object",
            properties: {
              key: { type: "string" },
              label: { type: "string" },
              thumb: {
                type: "object",
                properties: { name: { type: "string" } },
              },
              size: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    sku: { type: "string" },
                    key: { type: "string" },
                    label: { type: "string" },
                    real_stock: { type: "string" },
                    sale_stock: { type: "string" },
                    virtual_stock: { type: "string" },
                    supply_stock: { type: "string" },
                    status: { type: "boolean" },
                    update_stock: { type: "string" },
                    sku_sort: { type: "string" },
                    schedule_day: { type: "string" },
                    sku_name: { type: "string" },
                    in_stock_num: { type: "string" },
                    pre_in_stock_num: { type: "string" },
                    amount_stock_num: { type: "string" },
                  },
                },
              },
            },
          },
          description: "颜色尺码",
        },
        if_lock_time_end: {
          type: "string",
          description: "特价锁库时间是否过期 0 没过期 1过期",
        },
      },
    },
    requestFunctionName: "baobanPcGetSkuData",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetSkuData = /*#__PURE__*/ (
  requestData: BaobanPcGetSkuDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetSkuDataResponse>(
    prepare(baobanPcGetSkuDataRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetSkuData.requestConfig = baobanPcGetSkuDataRequestConfig;

export const useBaobanPcGetSkuData = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetSkuDataRequest,
  BaobanPcGetSkuDataRequestConfig,
  ReturnType<typeof baobanPcGetSkuData>
>(baobanPcGetSkuData);

export interface BaobanPcUpdateGoodsSkuRequest {
  /**
   * 启用的sku
   */
  sku: string[];
  /**
   *  goods_no
   */
  goods_no: string;
}

export interface BaobanPcUpdateGoodsSkuResponse {}

type BaobanPcUpdateGoodsSkuRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcUpdateGoodsSku",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcUpdateGoodsSkuRequestConfig: BaobanPcUpdateGoodsSkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcUpdateGoodsSku",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        sku: {
          type: "array",
          items: { type: "string" },
          description: "启用的sku",
        },
        goods_no: { type: "string", description: " goods_no" },
      },
      required: ["sku", "goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcUpdateGoodsSku",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcUpdateGoodsSku = /*#__PURE__*/ (
  requestData: BaobanPcUpdateGoodsSkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcUpdateGoodsSkuResponse>(
    prepare(baobanPcUpdateGoodsSkuRequestConfig, requestData),
    ...args,
  );
};

baobanPcUpdateGoodsSku.requestConfig = baobanPcUpdateGoodsSkuRequestConfig;

export const useBaobanPcUpdateGoodsSku = /*#__PURE__*/ makeRequestHook<
  BaobanPcUpdateGoodsSkuRequest,
  BaobanPcUpdateGoodsSkuRequestConfig,
  ReturnType<typeof baobanPcUpdateGoodsSku>
>(baobanPcUpdateGoodsSku);

export interface BaobanPcUpdateGoodsStockRequest {
  /**
   * colorSizeData
   */
  colorSizeData: {};
  /**
   * 锁库时间
   */
  lock_day: string;
  /**
   * 货号
   */
  goods_no: string;
}

export interface BaobanPcUpdateGoodsStockResponse {}

type BaobanPcUpdateGoodsStockRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcUpdateGoodsStock",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcUpdateGoodsStockRequestConfig: BaobanPcUpdateGoodsStockRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcUpdateGoodsStock",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        colorSizeData: {
          type: "object",
          properties: {},
          description: "colorSizeData",
        },
        lock_day: { type: "string", description: "锁库时间" },
        goods_no: { type: "string", description: "货号" },
      },
      required: ["colorSizeData", "lock_day", "goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcUpdateGoodsStock",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcUpdateGoodsStock = /*#__PURE__*/ (
  requestData: BaobanPcUpdateGoodsStockRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcUpdateGoodsStockResponse>(
    prepare(baobanPcUpdateGoodsStockRequestConfig, requestData),
    ...args,
  );
};

baobanPcUpdateGoodsStock.requestConfig = baobanPcUpdateGoodsStockRequestConfig;

export const useBaobanPcUpdateGoodsStock = /*#__PURE__*/ makeRequestHook<
  BaobanPcUpdateGoodsStockRequest,
  BaobanPcUpdateGoodsStockRequestConfig,
  ReturnType<typeof baobanPcUpdateGoodsStock>
>(baobanPcUpdateGoodsStock);

export interface BaobanPcUpdateSkuOnSaleRequest {
  /**
   * colorSizeData
   */
  colorSizeData: {};
  /**
   * 锁库时间
   */
  lock_day: string;
  /**
   * 货号
   */
  goods_no: string;
}

export interface BaobanPcUpdateSkuOnSaleResponse {}

type BaobanPcUpdateSkuOnSaleRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcUpdateSkuOnSale",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcUpdateSkuOnSaleRequestConfig: BaobanPcUpdateSkuOnSaleRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcUpdateSkuOnSale",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        colorSizeData: {
          type: "object",
          properties: {},
          description: "colorSizeData",
        },
        lock_day: { type: "string", description: "锁库时间" },
        goods_no: { type: "string", description: "货号" },
      },
      required: ["colorSizeData", "lock_day", "goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {},
    },
    requestFunctionName: "baobanPcUpdateSkuOnSale",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcUpdateSkuOnSale = /*#__PURE__*/ (
  requestData: BaobanPcUpdateSkuOnSaleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcUpdateSkuOnSaleResponse>(
    prepare(baobanPcUpdateSkuOnSaleRequestConfig, requestData),
    ...args,
  );
};

baobanPcUpdateSkuOnSale.requestConfig = baobanPcUpdateSkuOnSaleRequestConfig;

export const useBaobanPcUpdateSkuOnSale = /*#__PURE__*/ makeRequestHook<
  BaobanPcUpdateSkuOnSaleRequest,
  BaobanPcUpdateSkuOnSaleRequestConfig,
  ReturnType<typeof baobanPcUpdateSkuOnSale>
>(baobanPcUpdateSkuOnSale);

export interface BaobanPcNoCheckOnSaleRequest {
  /**
   * goods_no
   */
  goods_no: string;
}

export interface BaobanPcNoCheckOnSaleResponse {}

type BaobanPcNoCheckOnSaleRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcNoCheckOnSale",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcNoCheckOnSaleRequestConfig: BaobanPcNoCheckOnSaleRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcNoCheckOnSale",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: { goods_no: { type: "string", description: "goods_no" } },
      required: ["goods_no"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcNoCheckOnSale",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcNoCheckOnSale = /*#__PURE__*/ (
  requestData: BaobanPcNoCheckOnSaleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcNoCheckOnSaleResponse>(
    prepare(baobanPcNoCheckOnSaleRequestConfig, requestData),
    ...args,
  );
};

baobanPcNoCheckOnSale.requestConfig = baobanPcNoCheckOnSaleRequestConfig;

export const useBaobanPcNoCheckOnSale = /*#__PURE__*/ makeRequestHook<
  BaobanPcNoCheckOnSaleRequest,
  BaobanPcNoCheckOnSaleRequestConfig,
  ReturnType<typeof baobanPcNoCheckOnSale>
>(baobanPcNoCheckOnSale);

export interface BaobanPcImportGoodsDraftNoReviewRequest {
  /**
   *  1免审 0非免审
   */
  is_no_review: string;
  /**
   * 文件
   */
  file: string;
}

export interface BaobanPcImportGoodsDraftNoReviewResponse {
  /**
   * 错误的列表
   */
  list?: string[];
  /**
   * 文案
   */
  msg?: string;
}

type BaobanPcImportGoodsDraftNoReviewRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcImportGoodsDraftNoReview",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcImportGoodsDraftNoReviewRequestConfig: BaobanPcImportGoodsDraftNoReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcImportGoodsDraftNoReview",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        is_no_review: { type: "string", description: " 1免审 0非免审" },
        file: { type: "string", description: "文件" },
      },
      required: ["is_no_review", "file"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: { type: "string" },
          description: "错误的列表",
        },
        msg: { type: "string", description: "文案" },
      },
    },
    requestFunctionName: "baobanPcImportGoodsDraftNoReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcImportGoodsDraftNoReview = /*#__PURE__*/ (
  requestData: BaobanPcImportGoodsDraftNoReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcImportGoodsDraftNoReviewResponse>(
    prepare(baobanPcImportGoodsDraftNoReviewRequestConfig, requestData),
    ...args,
  );
};

baobanPcImportGoodsDraftNoReview.requestConfig =
  baobanPcImportGoodsDraftNoReviewRequestConfig;

export const useBaobanPcImportGoodsDraftNoReview =
  /*#__PURE__*/ makeRequestHook<
    BaobanPcImportGoodsDraftNoReviewRequest,
    BaobanPcImportGoodsDraftNoReviewRequestConfig,
    ReturnType<typeof baobanPcImportGoodsDraftNoReview>
  >(baobanPcImportGoodsDraftNoReview);

export interface BaobanPcGoodsListExportRequest {
  /**
   * 搜索
   */
  search_key: string;
  /**
   * 1.在售中 2.带上架 3.已下架 4.草稿
   */
  on_sale: string;
  /**
   * page
   */
  page: string;
  /**
   * page_size
   */
  page_size: string;
  /**
   * 品类筛选(数组)
   */
  cat_id: string[];
  /**
   * 标签信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) is_advance_support  提前上新  is_no_reason_support  无理由退货  goods_type  特价  has_consignment_stock  前置仓有库存  例子: 如果要传提前上新+特价, 那tag_info就传 "is_advance_support,goods_type"
   */
  tag_info: string;
  /**
   * 信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) no_real_img  无实拍图   no_video  无小视频  fill_in_sku_stock  已填库存需更新  un_stock_goods  前置仓滞销
   */
  message_info: string;
  /**
   * 价格筛选
   */
  market_price: {
    /**
     * min
     */
    min: string;
    /**
     * max
     */
    max: string;
  };
}

export interface BaobanPcGoodsListExportResponse {
  /**
   * 导出商品明细文件链接
   */
  file?: string;
}

type BaobanPcGoodsListExportRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGoodsListExport",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGoodsListExportRequestConfig: BaobanPcGoodsListExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGoodsListExport",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        search_key: { type: "string", description: "搜索" },
        on_sale: {
          type: "string",
          description: "1.在售中 2.带上架 3.已下架 4.草稿",
        },
        page: { type: "string", description: "page" },
        page_size: { type: "string", description: "page_size" },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "品类筛选(数组)",
        },
        tag_info: {
          type: "string",
          description:
            '标签信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) is_advance_support  提前上新  is_no_reason_support  无理由退货  goods_type  特价  has_consignment_stock  前置仓有库存  例子: 如果要传提前上新+特价, 那tag_info就传 "is_advance_support,goods_type"',
        },
        message_info: {
          type: "string",
          description:
            "信息筛选  (需要筛选什么, 就传什么选项过来, 多个用逗号隔开) no_real_img  无实拍图   no_video  无小视频  fill_in_sku_stock  已填库存需更新  un_stock_goods  前置仓滞销  ",
        },
        market_price: {
          type: "object",
          properties: {
            min: { type: "string", description: "min" },
            max: { type: "string", description: "max" },
          },
          required: ["min", "max"],
          description: "价格筛选",
        },
      },
      required: [
        "search_key",
        "cat_id",
        "page_size",
        "page",
        "on_sale",
        "market_price",
        "tag_info",
        "message_info",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        file: { type: "string", description: "导出商品明细文件链接" },
      },
    },
    requestFunctionName: "baobanPcGoodsListExport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGoodsListExport = /*#__PURE__*/ (
  requestData: BaobanPcGoodsListExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGoodsListExportResponse>(
    prepare(baobanPcGoodsListExportRequestConfig, requestData),
    ...args,
  );
};

baobanPcGoodsListExport.requestConfig = baobanPcGoodsListExportRequestConfig;

export const useBaobanPcGoodsListExport = /*#__PURE__*/ makeRequestHook<
  BaobanPcGoodsListExportRequest,
  BaobanPcGoodsListExportRequestConfig,
  ReturnType<typeof baobanPcGoodsListExport>
>(baobanPcGoodsListExport);

export interface BaobanPcGetGoodsColorListRequest {
  /**
   * 搜索的颜色
   */
  search_color: string;
}

export interface BaobanPcGetGoodsColorListResponse {
  list?: {
    /**
     * 颜色的id
     */
    id: string;
    /**
     * 颜色的值
     */
    label: string;
    /**
     * 背景颜色
     */
    hex: string;
    /**
     * 是否黑色字体  1是 0否
     */
    blackFont: string;
  }[];
}

type BaobanPcGetGoodsColorListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodsLibPc/baobanPcGetGoodsColorList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetGoodsColorListRequestConfig: BaobanPcGetGoodsColorListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodsLibPc/baobanPcGetGoodsColorList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        search_color: { type: "string", description: "搜索的颜色" },
      },
      required: ["search_color"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              id: { type: "string", description: "颜色的id" },
              label: { type: "string", description: "颜色的值" },
              hex: { type: "string", description: "背景颜色" },
              blackFont: {
                type: "string",
                description: "是否黑色字体  1是 0否",
              },
            },
            required: ["id", "label", "hex", "blackFont"],
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetGoodsColorList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetGoodsColorList = /*#__PURE__*/ (
  requestData: BaobanPcGetGoodsColorListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetGoodsColorListResponse>(
    prepare(baobanPcGetGoodsColorListRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetGoodsColorList.requestConfig =
  baobanPcGetGoodsColorListRequestConfig;

export const useBaobanPcGetGoodsColorList = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetGoodsColorListRequest,
  BaobanPcGetGoodsColorListRequestConfig,
  ReturnType<typeof baobanPcGetGoodsColorList>
>(baobanPcGetGoodsColorList);

export interface BaobanPcSetCollocationSortRequest {
  /**
   * id
   */
  id: string;
  /**
   * 排序
   */
  sort: string;
}

export interface BaobanPcSetCollocationSortResponse {}

type BaobanPcSetCollocationSortRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodslibPc/baobanPcSetCollocationSort",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSetCollocationSortRequestConfig: BaobanPcSetCollocationSortRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodslibPc/baobanPcSetCollocationSort",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        id: { type: "string", description: "id" },
        sort: { type: "string", description: "排序" },
      },
      required: ["id", "sort"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcSetCollocationSort",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSetCollocationSort = /*#__PURE__*/ (
  requestData: BaobanPcSetCollocationSortRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSetCollocationSortResponse>(
    prepare(baobanPcSetCollocationSortRequestConfig, requestData),
    ...args,
  );
};

baobanPcSetCollocationSort.requestConfig =
  baobanPcSetCollocationSortRequestConfig;

export const useBaobanPcSetCollocationSort = /*#__PURE__*/ makeRequestHook<
  BaobanPcSetCollocationSortRequest,
  BaobanPcSetCollocationSortRequestConfig,
  ReturnType<typeof baobanPcSetCollocationSort>
>(baobanPcSetCollocationSort);

export interface BaobanPcSetCollocationRequest {
  /**
   * 货号
   */
  goods_no: string;
  /**
   * 搭配的货号
   */
  target_goods_no: string;
  /**
   * 操作{1:关联,0:取消}
   */
  action: string;
}

export interface BaobanPcSetCollocationResponse {}

type BaobanPcSetCollocationRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodslibPc/baobanPcSetCollocation",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcSetCollocationRequestConfig: BaobanPcSetCollocationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodslibPc/baobanPcSetCollocation",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: { type: "string", description: "货号" },
        target_goods_no: { type: "string", description: "搭配的货号" },
        action: { type: "string", description: "操作{1:关联,0:取消}" },
      },
      required: ["goods_no", "target_goods_no", "action"],
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "baobanPcSetCollocation",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcSetCollocation = /*#__PURE__*/ (
  requestData: BaobanPcSetCollocationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcSetCollocationResponse>(
    prepare(baobanPcSetCollocationRequestConfig, requestData),
    ...args,
  );
};

baobanPcSetCollocation.requestConfig = baobanPcSetCollocationRequestConfig;

export const useBaobanPcSetCollocation = /*#__PURE__*/ makeRequestHook<
  BaobanPcSetCollocationRequest,
  BaobanPcSetCollocationRequestConfig,
  ReturnType<typeof baobanPcSetCollocation>
>(baobanPcSetCollocation);

export interface BaobanPcCollocationListRequest {
  /**
   * 搭配购的商品goods_no
   */
  goods_no: string;
  /**
   * 款号/标题
   */
  search_key: string;
  /**
   * 状态搜索  1.在售中 2.带上架 3.已下架
   */
  on_sale: string;
  /**
   * page
   */
  page: string;
  /**
   * page_size
   */
  page_size: string;
  /**
   * 分类筛选(json数组) [一级,二级, 三级]
   */
  cat_id: string[];
  /**
   * 价格筛选 [min=>33,max=>55]  json数组
   */
  market_price: {
    /**
     * 最小
     */
    min: string;
    /**
     * 最大
     */
    max: string;
  };
  tag_info: string;
  message_info: string;
}

export interface BaobanPcCollocationListResponse {
  list?: {
    /**
     * 搭配购的商品goods_no
     */
    goods_no: string;
    /**
     * 商品款号
     */
    goods_kh: string;
    /**
     * 商品名字
     */
    goods_name: string;
    /**
     * 分类名字
     */
    cat_name: string;
    /**
     * 拿货价
     */
    market_price: string;
    /**
     * 活动销售价
     */
    prefer_price: string;
    /**
     * 标签列表
     */
    tag_list: string[];
    /**
     * 首次上架时间
     */
    first_sale_period: string;
    /**
     * 最近上架时间
     */
    change_time: string;
    on_sale_name: string;
    /**
     * 排序
     */
    sort: string;
    /**
     * 是否是搭配购  1是 0否
     */
    is_collocation: string;
    /**
     * 搭配购id
     */
    collocation_id: string;
    /**
     * goods_img
     */
    goods_img: string;
  }[];
  total?: number;
}

type BaobanPcCollocationListRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodslibPc/baobanPcCollocationList",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcCollocationListRequestConfig: BaobanPcCollocationListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodslibPc/baobanPcCollocationList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: { type: "string", description: "搭配购的商品goods_no" },
        search_key: { type: "string", description: "款号/标题" },
        on_sale: {
          type: "string",
          description: "状态搜索  1.在售中 2.带上架 3.已下架",
        },
        page: { type: "string", description: "page" },
        page_size: { type: "string", description: "page_size" },
        cat_id: {
          type: "array",
          items: { type: "string" },
          description: "分类筛选(json数组) [一级,二级, 三级]",
        },
        market_price: {
          type: "object",
          properties: {
            min: { type: "string", description: "最小" },
            max: { type: "string", description: "最大" },
          },
          description: "价格筛选 [min=>33,max=>55]  json数组",
          required: ["min", "max"],
        },
      },
      required: [
        "goods_no",
        "search_key",
        "on_sale",
        "page",
        "page_size",
        "market_price",
        "cat_id",
      ],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              goods_no: { type: "string", description: "搭配购的商品goods_no" },
              goods_kh: { type: "string", description: "商品款号" },
              goods_name: { type: "string", description: "商品名字" },
              cat_name: { type: "string", description: "分类名字" },
              market_price: { type: "string", description: "拿货价" },
              prefer_price: { type: "string", description: "活动销售价" },
              tag_list: {
                type: "array",
                items: { type: "string" },
                description: "标签列表",
              },
              first_sale_period: {
                type: "string",
                description: "首次上架时间",
              },
              change_time: { type: "string", description: "最近上架时间" },
              on_sale_name: { type: "string" },
              sort: { type: "string", description: "排序" },
              is_collocation: {
                type: "string",
                description: "是否是搭配购  1是 0否",
              },
              collocation_id: { type: "string", description: "搭配购id" },
              goods_img: { type: "string", description: "goods_img" },
            },
            required: [
              "goods_no",
              "goods_kh",
              "goods_name",
              "cat_name",
              "market_price",
              "prefer_price",
              "tag_list",
              "first_sale_period",
              "change_time",
              "on_sale_name",
              "sort",
              "is_collocation",
              "collocation_id",
              "goods_img",
            ],
          },
        },
        total: { type: "number" },
      },
    },
    requestFunctionName: "baobanPcCollocationList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcCollocationList = /*#__PURE__*/ (
  requestData: BaobanPcCollocationListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcCollocationListResponse>(
    prepare(baobanPcCollocationListRequestConfig, requestData),
    ...args,
  );
};

baobanPcCollocationList.requestConfig = baobanPcCollocationListRequestConfig;

export const useBaobanPcCollocationList = /*#__PURE__*/ makeRequestHook<
  BaobanPcCollocationListRequest,
  BaobanPcCollocationListRequestConfig,
  ReturnType<typeof baobanPcCollocationList>
>(baobanPcCollocationList);

export interface BaobanPcGetSkuStockDataRequest {
  /**
   * 货号, 多个用逗号隔开
   */
  goods_no: string;
}

export interface BaobanPcGetSkuStockDataResponse {
  list?: {
    /**
     * goods_no
     */
    goods_no: string;
    sku: string;
    /**
     * 款号
     */
    goods_kh: string;
    /**
     * 名字
     */
    goods_name: string;
    /**
     * 颜色
     */
    co_val: string;
    /**
     * 尺码
     */
    si_val: string;
    /**
     * 前置仓库存
     */
    pre_in_stock_num: string;
    /**
     * 预售库存
     */
    sale_stock: string;
    /**
     * 合计库存
     */
    amount_stock_num: string;
    /**
     * 是否启用 1是 0否
     */
    status: string;
  }[];
}

type BaobanPcGetSkuStockDataRequestConfig = Readonly<
  RequestConfig<
    "http://yapi.yishou.com/mock/187",
    "",
    "",
    "/baoban/GoodslibPc/baobanPcGetSkuStockData",
    "data",
    string,
    string,
    false
  >
>;

const baobanPcGetSkuStockDataRequestConfig: BaobanPcGetSkuStockDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baoban/GoodslibPc/baobanPcGetSkuStockData",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
      type: "object",
      title: "empty object",
      properties: {
        goods_no: { type: "string", description: "货号, 多个用逗号隔开" },
      },
      required: ["goods_no"],
    },
    responseDataJsonSchema: {
      type: "object",
      properties: {
        list: {
          type: "array",
          items: {
            type: "object",
            properties: {
              goods_no: { type: "string", description: "goods_no" },
              sku: { type: "string" },
              goods_kh: { type: "string", description: "款号" },
              goods_name: { type: "string", description: "名字" },
              co_val: { type: "string", description: "颜色" },
              si_val: { type: "string", description: "尺码" },
              pre_in_stock_num: { type: "string", description: "前置仓库存" },
              sale_stock: { type: "string", description: "预售库存" },
              amount_stock_num: { type: "string", description: "合计库存" },
              status: { type: "string", description: "是否启用 1是 0否" },
            },
            required: [
              "goods_no",
              "goods_kh",
              "goods_name",
              "co_val",
              "si_val",
              "pre_in_stock_num",
              "sale_stock",
              "amount_stock_num",
              "status",
              "sku",
            ],
          },
        },
      },
    },
    requestFunctionName: "baobanPcGetSkuStockData",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

export const baobanPcGetSkuStockData = /*#__PURE__*/ (
  requestData: BaobanPcGetSkuStockDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<BaobanPcGetSkuStockDataResponse>(
    prepare(baobanPcGetSkuStockDataRequestConfig, requestData),
    ...args,
  );
};

baobanPcGetSkuStockData.requestConfig = baobanPcGetSkuStockDataRequestConfig;

export const useBaobanPcGetSkuStockData = /*#__PURE__*/ makeRequestHook<
  BaobanPcGetSkuStockDataRequest,
  BaobanPcGetSkuStockDataRequestConfig,
  ReturnType<typeof baobanPcGetSkuStockData>
>(baobanPcGetSkuStockData);

/* prettier-ignore-end */
